import { Stack } from '@mui/material'
import { FC } from 'react'

import EmailVerification from './EmailVerification'
import Title from './Title'

const ForgottenPasswordForm: FC = () => {
  return (
    <Stack>
      <Title mb={6}>Reset Password</Title>
      <EmailVerification formName="password_reset" />
    </Stack>
  )
}

export default ForgottenPasswordForm
